import appConf from '../app-conf'
const setup = appConf[process.env.REACT_APP_CLIENT]
const environment = process.env.NODE_ENV
const project = 'Change Password'
const server = null
const service = null

const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: {
    cms: {
      api: {
        endpoints: {
          list: {
            headers: {
              'Content-Type': 'application/json',
            },
            doc: 'https://tr4ns10.tr4ns.com/Westfield-Reporting',
            //url: "/Westfield-Reporting/report21?",
            url: setup.setup.api.tranxactor.url[environment] + '/configs',
            method: 'GET',
          },
          updatecognitouser: {
            headers: {
              'Content-Type': 'application/json',
              Authorization: null,
            },
            url: setup.setup.api.cms.url[environment] + '/mastercognitousers',
            method: 'PUT',
          },
        },
      },
      objects: {
        cognitoId: {
          name: 'cognitoId',
          initial: '',
          label: 'Cognito ID',
          helperText: false,
          rules: false,
        },
        name: {
          placeholder: '',
          name: 'name',
          initial: '',
          label: 'Name',
          helperText: false,
          rules: false,
        },
        userroles: {
          name: 'userroles',
          initial: '',
          label: 'User Role',
          type: 'select',
          options: [],
          helperText: false,
          rules: false,
        },
        mastercountries: {
          name: 'mastercountries',
          initial: [],
          label: 'Countries Applied',
          type: 'select',
          options: [],
          helperText: false,
          rules: false,
        },
      },
      responses: {
        fail: 'Incorrect email or password',
        unverified: 'Please verify your account by ticking the recaptcha.',
      },
    },
  },
  routes: {
    label: 'User Manage List',
    prefix: '/user/detail/:id',
    // prefix: "/:country/:lang/drag_and_drop"
  },
  environment,
  setup,
}

export default config
